import { create } from "zustand";
import { createQueueSlice, QueueSlice } from "./queue.slice";
import { createSelectionSlice, SelectionSlice } from "./selection.slice";
import { createToastSlice, ToastSlice } from "./toast.slice";

export interface TabloCompactStore
  extends QueueSlice,
    SelectionSlice,
    ToastSlice {
  reset: () => void;
}

export const useTabloCompactStore = create<TabloCompactStore>()(
  (set, get, api) => ({
    ...createQueueSlice(set, get, api),
    ...createSelectionSlice(set, get, api),
    ...createToastSlice(set, get, api),
    reset: () =>
      set({
        carNumber: "",
        queueRecord: null,
        driverPassOffices: [],
        selectedOfficeId: null,
        selectedChassisType: null,
        geoToken: null,
        toastMessage: null,
      }),
  }),
);
